import ReactHtmlParser from "react-html-parser";

function RawHtml({ data }) {
  const { html } = data;

  return <div data-testid="blockEditorRaw">{ReactHtmlParser(html)}</div>;
}

export { RawHtml };
